// Symbole je Abwesenheitsart (Handoff Personal, Prototyp personal-data.js). Farben kommen aus TYP_INFO.
import { AirplaneTilt, Coins, FirstAid, Gift, HourglassMedium, HouseLine, Stethoscope, SuitcaseRolling, type Icon } from '@phosphor-icons/react';
import type { AbwesenheitTyp } from '../../../../lib/zeiterfassung/abwesenheit';

export const TYP_ICON: Record<AbwesenheitTyp, Icon> = {
  urlaub: AirplaneTilt,
  krank: FirstAid,
  fza: HourglassMedium,
  homeoffice: HouseLine,
  dienstreise: SuitcaseRolling,
  sonderurlaub: Gift,
  unbezahlt: Coins,
  arzttermin: Stethoscope,
};
